import { useEffect, useRef, useState } from "react";

/** Окно, в которое второй тап считается двойным (как в мобильном клиенте). */
export const DOUBLE_TAP_WINDOW_MS = 300;

/**
 * Двойной тап по фото карточки ставит лайк — как в мобильном клиенте
 * (useTapOrDoubleTap). Одиночный тап по-прежнему открывает товар.
 *
 * Только для касаний: с мышью первый клик сразу ведёт в карточку, как и раньше.
 * На тач-экране одиночный тап приходится отложить на окно двойного — иначе
 * первый тап уводил бы со страницы и второму некуда было бы попасть.
 */
export function useDoubleTapLike({
	onOpen,
	onLike,
	windowMs = DOUBLE_TAP_WINDOW_MS,
}: {
	onOpen: () => void;
	onLike: () => void;
	windowMs?: number;
}) {
	const pointerType = useRef<string>("mouse");
	const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
	// Счётчик вспышек сердца поверх фото: новый ключ — новая анимация.
	const [burst, setBurst] = useState(0);

	useEffect(
		() => () => {
			if (timer.current) clearTimeout(timer.current);
		},
		[],
	);

	return {
		burst,
		onPointerDown: (e: React.PointerEvent) => {
			pointerType.current = e.pointerType;
		},
		onClick: (e: React.MouseEvent) => {
			if (pointerType.current !== "touch") return; // мышь/клавиатура — обычный переход
			e.preventDefault();
			if (timer.current) {
				clearTimeout(timer.current);
				timer.current = null;
				onLike();
				setBurst((n) => n + 1);
				return;
			}
			timer.current = setTimeout(() => {
				timer.current = null;
				onOpen();
			}, windowMs);
		},
	};
}
